<div class="provider-card" (click)="viewProviderDetails()">
    <div class="card-content">
        <div class="provider-header">
            <img 
                [src]="provider.photo || 'vudprovider.png'" 
                alt="provider photo"
                class="provider-image"
                (click)="viewProviderDetails()">
            <div class="provider-info">
                <div class="provider-name" (click)="viewProviderDetails()">{{provider.providerName}}</div>
                <div class="provider-specialty">{{provider.specialties}}</div>
                
                <div class="provider-details">
                    <div class="detail-row" *ngIf="provider.address1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 6 9" fill="none">
                        <ellipse cx="2.72048" cy="2.5" rx="2.72048" ry="2.5" fill="#959595"/>
                        <line x1="2.67639" y1="4" x2="2.67639" y2="9" stroke="#959595"/>
                        </svg>
                        <div class="detail-text" (click)="onGetDirections($event);">
                            <div>{{provider.address1}}</div>
                            <div *ngIf="provider.city && provider.zip">{{provider.city}}, CA {{provider.zip}}</div>
                        </div>
                    </div>

                    <div class="detail-row" style="padding-top: 6px;" *ngIf="provider.phone">
                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none">
                            <path d="M6.74543 8.25001C5.16269 8.24803 3.64536 7.63895 2.5262 6.55636C1.40703 5.47377 0.777381 4.00603 0.77533 2.47501C0.77533 2.01751 0.96321 1.57875 1.29764 1.25525C1.63207 0.931753 2.08565 0.750012 2.55861 0.750012C2.65876 0.749274 2.75874 0.758067 2.85711 0.776262C2.95221 0.789875 3.0457 0.812483 3.13623 0.843762C3.19991 0.865373 3.25665 0.902687 3.30084 0.952014C3.34504 1.00134 3.37515 1.06097 3.38822 1.12501L3.91932 3.37501C3.93364 3.43609 3.93192 3.49966 3.91431 3.55992C3.8967 3.62018 3.86378 3.67522 3.81853 3.72001C3.76813 3.77251 3.76426 3.77626 3.28742 4.01626C3.66928 4.82658 4.33925 5.47732 5.17537 5.85001C5.42736 5.38501 5.43123 5.38126 5.48551 5.33251C5.53181 5.28875 5.58871 5.25689 5.65101 5.23986C5.71331 5.22283 5.77903 5.22116 5.84216 5.23501L8.16818 5.74876C8.23226 5.76314 8.2915 5.79307 8.34034 5.83571C8.38917 5.87835 8.42598 5.93231 8.4473 5.99251C8.48002 6.08152 8.50466 6.17312 8.52095 6.26626C8.53656 6.36051 8.54434 6.45581 8.54422 6.55126C8.53707 7.00681 8.3439 7.44111 8.0069 7.75938C7.66989 8.07765 7.2164 8.25403 6.74543 8.25001V8.25001Z" fill="#888888"/>
                        </svg>
                        <div class="detail-text" (click)="onCallPhone($event);">{{provider.phone}}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card-footer">
            <div class="footer-left">
                <div class="detail-row" *ngIf="provider.distanceInMiles">
                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="10" viewBox="0 0 9 10" fill="none">
                        <path d="M8.96777 0L5.28893 9.09812L4.03928 5.09906L1.04967e-05 3.98612L8.96777 0Z" fill="#959595"/>
                    </svg>
                    <div class="detail-text-miles">{{provider.distanceInMiles}}{{milesAwayText}}</div>
                </div>
            </div>
            <div class="footer-right">
                <div class="availability" *ngIf="provider.nextAvailability">
                    <span class="availability-label">{{soonAsText}}</span>
                    <span class="availability-date">{{waitTime}}</span>
                </div>
                <button 
                    mat-button 
                    class="action-button"
                    (click)="$event.stopPropagation(); (provider.nextAvailability != null || (provider.openScheduling != null && provider.openScheduling == true && provider.departmentId != null)) ? onScheduleButtonClicked() : onCallPhone($event)">
                    {{(provider.nextAvailability != null || (provider.openScheduling != null && provider.openScheduling == true && provider.departmentId != null)) ? scheduleText : noAvailabilityStr }}
                </button>
            </div>
        </div>
    </div>
</div>
